<template>
    <div class="home">
        <!-- 首页内容 -->
        <div class="myswiper">
            <div class>
                <div class="swiper-button-prev mySwiperBtn"></div>
                <div class="swiper-button-next mySwiperBtn"></div>
            </div>
            <swiper :options="HomeBanner" ref="imgOverview">
                <swiper-slide v-for="(item, index) in bannerData" :key="index">
                    <a :href="bannerLink(item.image.name)">
                        <div class="swiper-zoom-container">
                            <img :src="item.image.url" :alt="item.image.name" />
                        </div>
                    </a>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>

        <products></products>
        <about :isAbout="isAbout"></about>
        <partner></partner>
    </div>
</template>
<script>
    import baseData from '../data/CN/basicinfoData_CN.json'
    import homeswiperCN from '../data/CN/homeswiper_CN.json'
    import homeswiperEN from '../data/EN/homeswiper_EN.json'
    import homeswiperJP from '../data/JP/homeswiper_JP.json'
    import products from '../components/HomeProducts'
    import about from '../components/HomeAbout'
    import partner from '../components/HomePartner'
    export default {
        data() {
            return {
                isAbout: false,
                HomeBanner: {
                    // 显示分页
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets'
                    },
                    autoplay: {
                        delay: 3000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        hideOnClick: true,
                        hiddenClass: 'swiper-button-hidden'
                    },
                    // 开启循环模式
                    loop: true,
                    // 开启鼠标滚轮控制Swiper切换
                    mousewheel: false
                },
                // 轮播图数据
                bannerData: [],
                // 基本信息数据
                basicinfoData: {},
                currentLanguage: ""
            }
        },
        mounted() {
            const _this = this
            window.addEventListener('setItemEvent', function(e) {
                // e.key : 是值发生变化的key
                // 例如 e.key==="token";
                // e.newValue : 是可以对应的新值
                if (e.key === 'language') {
                    var d = e.newValue
                    this.currentLanguage = e.newValue
                    if (d === 'CN') {
                        _this.bannerData = homeswiperCN
                    } else if (d === 'EN') {
                        _this.bannerData = homeswiperEN
                    } else if (d === 'JP') {
                        _this.bannerData = homeswiperJP
                    }
                }
            })
        },
        methods: {
            bannerLink: function(name) {
                let link = ''
                if (name.indexOf('www') !== -1) {
                    link = 'http://' + name.replace('.jpg', '')
                    return link
                } else {
                    return ''
                }
            },
            // 查询所有的基本信息
            findBasicinfo: function() {
                this.basicinfoData = baseData
                // const res = await this.$http.get('basicinfo')
                // this.basicinfoData = res.data[0]
            },
            // 查询所有的轮播图
            findBanner: async function() {
                var lg = localStorage.getItem('language')
                this.currentLanguage = lg
                if (lg === 'CN') {
                    this.bannerData = homeswiperCN
                } else if (lg === 'EN') {
                    this.bannerData = homeswiperEN
                } else if (lg === 'JP') {
                    this.bannerData = homeswiperJP
                }
            }
        },
        created() {
            this.findBasicinfo()
            this.findBanner()
        },
        components: {
            products: products,
            about: about,
            partner: partner
        }
    }
</script>
<style scoped>
    .mySwiperBtn {
        z-index: 99;
    }

    .swiper-button-hidden {
        opacity: 0;
    }

    .myswiper {
        position: relative;
    }

    .mySwiperBtn {
        outline: none;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.6);
        /* position: absolute; */
    }

    .mySwiperBtn::after {
        font-size: 26px !important;
    }
</style>
